export default __webpack_public_path__ + "static/media/background.7d9efe84.png";